var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExercise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7995 20.4282C5.7995 20.4282 -0.0408907 36.6515 10.3686 35.211C20.778 33.7705 35.9864 44.9446 37.6572 31.3352C39.3297 17.7258 36.7889 5.37642 31.4173 4.11459C26.0457 2.85276 12.6431 -0.276962 5.7995 20.4282Z",
    fill: "#B49D70",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3335 12.332H13.3335C12.7812 12.332 12.3335 12.7797 12.3335 13.332V29.332C12.3335 29.8843 12.7812 30.332 13.3335 30.332H16.3335C16.8858 30.332 17.3335 29.8843 17.3335 29.332V13.332C17.3335 12.7797 16.8858 12.332 16.3335 12.332Z",
    stroke: "url(#paint0_linear_1786_44851)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3335 12.332H26.3335C25.7812 12.332 25.3335 12.7797 25.3335 13.332V29.332C25.3335 29.8843 25.7812 30.332 26.3335 30.332H29.3335C29.8858 30.332 30.3335 29.8843 30.3335 29.332V13.332C30.3335 12.7797 29.8858 12.332 29.3335 12.332Z",
    stroke: "url(#paint1_linear_1786_44851)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3335 15.332H33.3335C33.5987 15.332 33.8531 15.4374 34.0406 15.6249C34.2281 15.8125 34.3335 16.0668 34.3335 16.332V26.332C34.3335 26.5972 34.2281 26.8516 34.0406 27.0391C33.8531 27.2267 33.5987 27.332 33.3335 27.332H30.3335",
    stroke: "url(#paint2_linear_1786_44851)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3335 27.332H9.3335C9.06828 27.332 8.81393 27.2267 8.62639 27.0391C8.43885 26.8516 8.3335 26.5972 8.3335 26.332V16.332C8.3335 16.0668 8.43885 15.8125 8.62639 15.6249C8.81393 15.4374 9.06828 15.332 9.3335 15.332H12.3335",
    stroke: "url(#paint3_linear_1786_44851)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3335 21.332H25.3335",
    stroke: "url(#paint4_linear_1786_44851)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3335 21.332H36.3335",
    stroke: "url(#paint5_linear_1786_44851)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3335 21.332H8.3335",
    stroke: "url(#paint6_linear_1786_44851)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1786_44851",
    x1: 12.3335,
    y1: 12.332,
    x2: 21.6178,
    y2: 14.9115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A9588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B796D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1786_44851",
    x1: 25.3335,
    y1: 12.332,
    x2: 34.6178,
    y2: 14.9115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A9588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B796D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1786_44851",
    x1: 30.3335,
    y1: 15.332,
    x2: 37.5339,
    y2: 17.7326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A9588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B796D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1786_44851",
    x1: 8.3335,
    y1: 15.332,
    x2: 15.5339,
    y2: 17.7326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A9588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B796D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1786_44851",
    x1: 17.3335,
    y1: 21.332,
    x2: 17.5796,
    y2: 23.3011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A9588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B796D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1786_44851",
    x1: 34.3335,
    y1: 21.332,
    x2: 35.1333,
    y2: 22.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A9588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B796D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1786_44851",
    x1: 6.3335,
    y1: 21.332,
    x2: 7.13334,
    y2: 22.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A9588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B796D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExercise);
export default __webpack_public_path__ + "static/media/exercise.bd90bf90d60fa7173a431de2289d0c23.svg";
export { ForwardRef as ReactComponent };